// contexts/SnackbarContext.jsx
import { createContext, useContext, useState, useCallback } from "react";
import { Snackbar, Alert } from "@mui/material";
import Slide from "@mui/material/Slide"; // or whatever transition you prefer

const SnackbarContext = createContext(null);

function SlideTransition(props) {
  return <Slide {...props} direction="down" />;
}

export function SnackbarProvider({ children }) {
  const [state, setState] = useState({
    open: false,
    message: "",
    severity: "info", // "success" | "error" | "warning" | "info"
    Transition: SlideTransition,
  });

  const showSnackbar = useCallback((message, severity = "error") => {
    setState({
      open: true,
      message,
      severity,
      Transition: SlideTransition,
    });
  }, []);

  const hideSnackbar = useCallback(() => {
    setState((prev) => ({ ...prev, open: false }));
  }, []);

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}

      <Snackbar
        open={state.open}
        onClose={hideSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        slots={{ transition: state.Transition }}
        key={state.message} // forces re-mount when message changes
        autoHideDuration={5000}
      >
        <Alert
          onClose={hideSnackbar}
          severity={state.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {state.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
}

export function useSnackbar() {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error("useSnackbar must be used within a SnackbarProvider");
  }
  return context;
}
